module.exports = __webpack_public_path__ + "static/media/exploring-an-industry.542c6895.pdf";